import {Input, InputNumber, Form} from "antd";

export const InputFilter = ({name = 'input', inputType = 'input', width = 200, ...rest}) => {
    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                {(inputType === 'number')
                    ? (
                        <InputNumber
                            placeholder="input text"
                            style={{
                                width,
                            }}
                            {...rest}
                        />
                    )
                    : (
                        <Input
                            placeholder="input text"
                            style={{
                                width,
                            }}
                            {...rest}
                        />
                    )
                }
            </Form.Item>
        </>
    );
}